import {Component} from 'react'
import {connect} from 'react-redux'
import '../../sass/toolbar-panel.css'

class SprintRateToolbarPanel extends Component {

    render() {
        return null
    }
}

function mapStateToProps(state, props) {
    return {
    }
}


export default connect(mapStateToProps)(SprintRateToolbarPanel)



// WEBPACK FOOTER //
// ./src/components/toolbar/SprintRateToolbarPanel.js